import React from "react";
import { useNavigate } from "react-router-dom";
import tw from "twin.macro";

export const VERSION = "1.5.4";

const VersionNotesButton: React.FC = () => {
  const navigate = useNavigate();
  return (
    <>
      <div
        css={[tw`flex-none self-start`]}
        style={{
          cursor: "pointer",
        }}
        onClick={() => navigate("/version-history")}
      >
        <span css={[tw`text-sm`]}>v{VERSION}</span>
      </div>
    </>
  );
};

export default VersionNotesButton;
